import {
  endOfMonth,
  endOfWeek,
  startOfMonth,
  startOfWeek,
  startOfYesterday,
  subMonths,
  subWeeks,
} from "date-fns";

import type { CustomDate, SelectGeneric } from "@/types";

export const NEXT_AUTH_PATH_NAME = "/auth";
export const UNDERSCORE_NEXT_PATH_NAME = "/_next";
export const TOTP_QR_TEMPLATE =
  "otpauth://totp/AWSCognito:[USERNAME]?secret=[SECRET]&issuer=Telered%20BI";
export const MANDATORY_MFA_TYPE = "TOTP";

export const CLIENT_ROLES = ["Client Admin", "Client"];

export const ADMIN_ROLES = [0, 1, 2, 7];

export const WordTimezone = [
  { label: "America/New York", value: "America/New_York" },
  { label: "America/Detroit", value: "America/Detroit" },
  {
    label: "America/Kentucky/Louisville",
    value: "America/Kentucky/Louisville",
  },
  {
    label: "America/Kentucky/Monticello",
    value: "America/Kentucky/Monticello",
  },
  {
    label: "America/Indiana/Indianapolis",
    value: "America/Indiana/Indianapolis",
  },
  { label: "America/Indiana/Vincennes", value: "America/Indiana/Vincennes" },
  { label: "America/Indiana/Winamac", value: "America/Indiana/Winamac" },
  { label: "America/Indiana/Marengo", value: "America/Indiana/Marengo" },
  { label: "America/Indiana/Petersburg", value: "America/Indiana/Petersburg" },
  { label: "America/Indiana/Vevay", value: "America/Indiana/Vevay" },
  { label: "America/Chicago", value: "America/Chicago" },
  { label: "America/Indiana/Tell_City", value: "America/Indiana/Tell_City" },
  { label: "America/Indiana/Knox", value: "America/Indiana/Knox" },
  { label: "America/Menominee", value: "America/Menominee" },
  {
    label: "America/North Dakota/Center",
    value: "America/North_Dakota/Center",
  },
  {
    label: "America/North Dakota/New_Salem",
    value: "America/North_Dakota/New_Salem",
  },
  {
    label: "America/North Dakota/Beulah",
    value: "America/North_Dakota/Beulah",
  },
  { label: "America/Denver", value: "America/Denver" },
  { label: "America/Boise", value: "America/Boise" },
  { label: "America/Phoenix", value: "America/Phoenix" },
  { label: "America/Los Angeles", value: "America/Los_Angeles" },
  { label: "America/Anchorage", value: "America/Anchorage" },
  { label: "America/Juneau", value: "America/Juneau" },
  { label: "America/Sitka", value: "America/Sitka" },
  { label: "America/Metlakatla", value: "America/Metlakatla" },
  { label: "America/Yakutat", value: "America/Yakutat" },
  { label: "America/Nome", value: "America/Nome" },
  { label: "America/Adak", value: "America/Adak" },
  { label: "Pacific/Honolulu", value: "Pacific/Honolulu" },
];

export const TeleredTheme = {
  PRIMARY_COLOR: "#213564",
  SECONDARY_COLOR: "#A4C7E2",
  CHARTS: {
    LINE: {
      COLOR: {
        BLUE: "#1E9DC6",
        GREEN: "#27AB44",
        GRAY: "#DBDBDB",
        GRAY_POINT: "#979797",
        RED: "#E2271B",
      },
    },
  },
};

export const ClientTypes: SelectGeneric[] = [
  {
    id: "1",
    name: "FQHC",
  },
  {
    id: "2",
    name: "Physician's Office",
  },
  {
    id: "3",
    name: "LTAC",
  },
];

export const SpecimenSource: SelectGeneric[] = [
  { id: "1", name: "Abdomin" },
  { id: "1", name: "Abdominal Fluid" },
  { id: "1", name: "Abscess" },
  { id: "1", name: "Amniotic Fluid" },
  { id: "1", name: "Ankle" },
  { id: "1", name: "Ankle, Left" },
  { id: "1", name: "Ankle, Right" },
  { id: "1", name: "Anus" },
  { id: "1", name: "Arm" },
  { id: "1", name: "Arm, Left" },
  { id: "1", name: "Arm, Right" },
  { id: "1", name: "Ascites Fluid" },
  { id: "1", name: "Aspirate Transtracheal" },
  { id: "1", name: "Axilla" },
  { id: "1", name: "Back" },
  { id: "1", name: "BAL" },
  { id: "1", name: "Bile" },
  { id: "1", name: "Bile Duct Brushing" },
  { id: "1", name: "Bite" },
  { id: "1", name: "Bladder" },
  { id: "1", name: "Bladder Aspirate" },
  { id: "1", name: "Blood Arterial" },
  { id: "1", name: "Blood Arterial Line" },
  { id: "1", name: "Blood Capillary" },
  { id: "1", name: "Blood Peripheal" },
  { id: "1", name: "Blood Venous" },
  { id: "1", name: "Bone" },
  { id: "1", name: "Bone Marrow" },
  { id: "1", name: "Brain" },
  { id: "1", name: "Breast" },
  { id: "1", name: "Breast Milk" },
  { id: "1", name: "Breath" },
  { id: "1", name: "Bronchial Brushing" },
  { id: "1", name: "Buttock" },
  { id: "1", name: "Calf" },
  { id: "1", name: "Cath Site" },
  { id: "1", name: "Catheter Tip" },
  { id: "1", name: "Cerebrospinal Fluid" },
  { id: "1", name: "Cervical" },
  { id: "1", name: "Cervical Vaginal" },
  { id: "1", name: "Cervix" },
  { id: "1", name: "Cheek" },
  { id: "1", name: "Chest" },
  { id: "1", name: "Chin" },
  { id: "1", name: "Coccyx" },
  { id: "1", name: "Colon" },
  { id: "1", name: "Conjunctival Scraping" },
  { id: "1", name: "Cornea Tissue" },
  { id: "1", name: "Corneal" },
  { id: "1", name: "Cul-De-Sac" },
  { id: "1", name: "Cyst, Other" },
  { id: "1", name: "Dermal" },
  { id: "1", name: "Dialysate" },
  { id: "1", name: "Drainage" },
  { id: "1", name: "Ear" },
  { id: "1", name: "Ear, Left" },
  { id: "1", name: "Ear, Right" },
  { id: "1", name: "Earlobe" },
  { id: "1", name: "Elbow" },
  { id: "1", name: "Elbow, Left" },
  { id: "1", name: "Elbow, Right" },
  { id: "1", name: "Endometrial" },
  { id: "1", name: "Esophagus" },
  { id: "1", name: "Eye" },
  { id: "1", name: "Eye, Left" },
  { id: "1", name: "Eye, Right" },
  { id: "1", name: "Eyelid" },
  { id: "1", name: "Face" },
  { id: "1", name: "Finger" },
  { id: "1", name: "Fingernail" },
  { id: "1", name: "Fistula" },
  { id: "1", name: "Foot" },
  { id: "1", name: "Foot, Left" },
  { id: "1", name: "Foot, Right" },
  { id: "1", name: "Forehead" },
  { id: "1", name: "Foreskin" },
  { id: "1", name: "Gallbladder" },
  { id: "1", name: "Gastric" },
  { id: "1", name: "Genital" },
  { id: "1", name: "Graft Site" },
  { id: "1", name: "Groin" },
  { id: "1", name: "Hair" },
  { id: "1", name: "Hand" },
  { id: "1", name: "Hand, Left" },
  { id: "1", name: "Hand, Right" },
  { id: "1", name: "Head" },
  { id: "1", name: "Heart" },
  { id: "1", name: "Heel" },
  { id: "1", name: "Hip" },
  { id: "1", name: "Hip, Left" },
  { id: "1", name: "Hip, Right" },
  { id: "1", name: "Intrauterine Device" },
  { id: "1", name: "Jaw" },
  { id: "1", name: "Joint" },
  { id: "1", name: "Kidney" },
  { id: "1", name: "Knee" },
  { id: "1", name: "Knee, Left" },
  { id: "1", name: "Knee, Right" },
  { id: "1", name: "Labia" },
  { id: "1", name: "Leg" },
  { id: "1", name: "Leg, Left" },
  { id: "1", name: "Leg, Right" },
  { id: "1", name: "Lesion" },
  { id: "1", name: "Lip" },
  { id: "1", name: "Liver" },
  { id: "1", name: "Lung" },
  { id: "1", name: "Lymph Node" },
  { id: "1", name: "Mouth" },
  { id: "1", name: "Muscle" },
  { id: "1", name: "Nares" },
  { id: "1", name: "Nasal" },
  { id: "1", name: "Nasal Wash" },
  { id: "1", name: "Nasopharyngeal" },
  { id: "1", name: "Nasopharyngeal Wash" },
  { id: "1", name: "Nasopharynx" },
  { id: "1", name: "Navel" },
  { id: "1", name: "Neck" },
  { id: "1", name: "Nipple" },
  { id: "1", name: "Nose" },
  { id: "1", name: "Other" },
  { id: "1", name: "Pancreas" },
  { id: "1", name: "Paracentesis Fluid" },
  { id: "1", name: "Parotid" },
  { id: "1", name: "Pelvic Wash" },
  { id: "1", name: "Penis" },
  { id: "1", name: "Pericardial" },
  { id: "1", name: "Pericardium" },
  { id: "1", name: "Perirectal" },
  { id: "1", name: "Peritoneal" },
  { id: "1", name: "Peritoneum" },
  { id: "1", name: "Pharynx" },
  { id: "1", name: "Placenta" },
  { id: "1", name: "Pleural" },
  { id: "1", name: "Products of Conception" },
  { id: "1", name: "Prostate" },
  { id: "1", name: "Rectal" },
  { id: "1", name: "Rectum" },
  { id: "1", name: "Respiratory" },
  { id: "1", name: "Saliva" },
  { id: "1", name: "Scalp" },
  { id: "1", name: "Scrotum" },
  { id: "1", name: "Semen" },
  { id: "1", name: "Shoulder" },
  { id: "1", name: "Sinus" },
  { id: "1", name: "Sinus Maxillary" },
  { id: "1", name: "Skin" },
  { id: "1", name: "Skin, Shave" },
  { id: "1", name: "Sputum" },
  { id: "1", name: "Stomach" },
  { id: "1", name: "Stone" },
  { id: "1", name: "Stool" },
  { id: "1", name: "Synovial Fluid" },
  { id: "1", name: "Testicle" },
  { id: "1", name: "Thigh" },
  { id: "1", name: "Throat" },
  { id: "1", name: "Thumb" },
  { id: "1", name: "Tissue" },
  { id: "1", name: "Toe" },
  { id: "1", name: "Toenail" },
  { id: "1", name: "Tongue" },
  { id: "1", name: "Tonsil" },
  { id: "1", name: "Tooth" },
  { id: "1", name: "Tracheal" },
  { id: "1", name: "Tumor" },
  { id: "1", name: "Urethral" },
  { id: "1", name: "Urine Clean Catch" },
  { id: "1", name: "Urine Nephrostomy" },
  { id: "1", name: "Urine Pedibag" },
  { id: "1", name: "Urine Staight Catheter" },
  { id: "1", name: "Urine Void" },
  { id: "1", name: "Uterus" },
  { id: "1", name: "Vagina" },
  { id: "1", name: "Vaginal" },
  { id: "1", name: "Vaginal/Rectal" },
  { id: "1", name: "VP Shunt" },
  { id: "1", name: "Vulva" },
  { id: "1", name: "Wound" },
  { id: "1", name: "Wrist" },
  { id: "1", name: "Wrist, Left" },
  { id: "1", name: "Wrist, Right" },
];

export const SpecimenType: SelectGeneric[] = [
  { id: "1", name: "Abscess" },
  { id: "1", name: "Biopsy" },
  { id: "1", name: "Blood" },
  { id: "1", name: "Body Fluid" },
  { id: "1", name: "Bone" },
  { id: "1", name: "Bone Marrow" },
  { id: "1", name: "Conjuctival Scraping" },
  { id: "1", name: "CSF" },
  { id: "1", name: "Cyst" },
  { id: "1", name: "Ear" },
  { id: "1", name: "Eye" },
  { id: "1", name: "Genital" },
  { id: "1", name: "Hair" },
  { id: "1", name: "Lesion" },
  { id: "1", name: "Lymph Node" },
  { id: "1", name: "Nails" },
  { id: "1", name: "Other" },
  { id: "1", name: "Polyp" },
  { id: "1", name: "Products of Conception" },
  { id: "1", name: "Respiratory" },
  { id: "1", name: "Saliva" },
  { id: "1", name: "Skin" },
  { id: "1", name: "Stone" },
  { id: "1", name: "Stool" },
  { id: "1", name: "Synovial Fluid" },
  { id: "1", name: "Tissue" },
  { id: "1", name: "Urine" },
  { id: "1", name: "Wound" },
];

export const CollectionStatus: SelectGeneric[] = [
  { id: "1", name: "Patient refused" },
  { id: "2", name: "Patient discharged" },
  { id: "3", name: "Patient not in room" },
  { id: "4", name: "Other" },
];

export const ClientConnections: SelectGeneric[] = [
  {
    id: "1",
    name: "Direct Connect",
  },
  {
    id: "2",
    name: "Portal",
  },
  {
    id: "3",
    name: "Manual",
  },
];

export const TABLE_DEFAULT_PER_PAGE = 10;

export const GENDER = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
  { label: "Unknown", value: "unknown" },
];

export const MARTIAL_STATUS = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Other", value: "Other" },
];

export const ETHNICITY = [
  { label: "African", value: "African" },
  { label: "Afrodescendant", value: "Afrodescendant" },
  { label: "Arab", value: "Arab" },
  { label: "Asian", value: "Asian" },
  { label: "Caucasian", value: "Caucasian" },
  { label: "Hispanic", value: "Hispanic" },
  { label: "Indigenous", value: "Indigenous" },
  { label: "Inuit", value: "Inuit" },
  { label: "Mixed race", value: "Mixed race" },
  { label: "Black", value: "Black" },
  { label: "Nordic", value: "Nordic" },
  { label: "Rromani (Gypsy)", value: "Rromani (Gypsy)" },
  { label: "Sámi", value: "Sámi" },
  { label: "African American", value: "African American" },
  { label: "Amerindian", value: "Amerindian" },
  { label: "Australian Aboriginal", value: "Australian Aboriginal" },
  { label: "Maori", value: "Maori" },
  { label: "Bantu", value: "Bantu" },
  { label: "Bribri", value: "Bribri" },
  { label: "Quechua", value: "Quechua" },
];

export const PHONE_TYPE = [
  { label: "Home", value: "Home" },
  { label: "Work", value: "Work" },
  { label: "Mobile", value: "Mobile" },
];

export const PREFERRED_CONTACT = [
  { label: "Email", value: "Email" },
  { label: "Cell Phone", value: "Cell Phone" },
];

export const RACE = [
  { label: "Caucasian", value: "Caucasian" },
  { label: "African", value: "African" },
  { label: "Asian", value: "Asian" },
  { label: "Native American", value: "Native American" },
  { label: "Pacific Islander", value: "Pacific Islander" },
  { label: "Aboriginal Australian", value: "Aboriginal Australian" },
  { label: "Indigenous Peoples", value: "Indigenous Peoples" },
  { label: "Mixed Race", value: "Mixed Race" },
  { label: "Other", value: "Other" },
];

export const POLICY_RELATIONSHIP = [
  { label: "Self", value: "Self" },
  { label: "Spouse", value: "Spouse" },
  { label: "Child", value: "Child" },
  { label: "Other", value: "Other" },
];

export const INSURANCE_PROVIDER = [{ label: "Other", value: "Other" }];

export const INSURANCE_TYPE = [
  { label: "Primary", value: "Primary" },
  { label: "Secondary", value: "Secondary" },
  { label: "Tertiary", value: "Tertiary" },
];

export const BILL_TO = [
  { label: "Insurance", value: "Insurance" },
  { label: "Client Bill", value: "Client Bill" },
  { label: "Self Pay", value: "Self Pay" },
];

export const reportBuilderColumns = [
  {
    name: "Performing Lab Order ID",
    id: "performingLabOrderId",
  },
  {
    name: "Ordering Lab Order ID",
    id: "orderingLabOrderId",
  },
  {
    name: "Ordering Lab",
    id: "orderingLab",
  },
  {
    name: "Ordering Lab Address",
    id: "orderingLabAddress",
  },
  {
    name: "Performing Lab",
    id: "performingLab",
  },
  {
    name: "Performing Lab Address",
    id: "performingLabAddress",
  },
  {
    name: "Patient First Name",
    id: "patientFirstName",
  },
  {
    name: "Patient Last Name",
    id: "patientLastName",
  },
  {
    name: "MRN",
    id: "MRN",
  },
  {
    name: "Patient Address",
    id: "patientAddress",
  },
  {
    name: "Gender",
    id: "gender",
  },
  {
    name: "DOB",
    id: "DOB",
  },
  {
    name: "Ordering Provider",
    id: "orderingProvider",
  },
  {
    name: "Ordering Provider NPI",
    id: "orderingProviderNPI",
  },
  {
    name: "Ordering Provider Address",
    id: "orderingProviderAddress",
  },
  {
    name: "Panel Name",
    id: "panelName",
  },
  {
    name: "Ordered Date",
    id: "orderedDate",
  },
  {
    name: "Collected Date",
    id: "collectedDate",
  },
  {
    name: "Resulted Date",
    id: "resultedDate",
  },
  {
    name: "Canceled Date",
    id: "canceledDate",
  },
  {
    name: "Cancel Reason",
    id: "cancelReason",
  },
  {
    name: "Rejected Date",
    id: "rejectedDate",
  },
  {
    name: "Test Price",
    id: "testPrice",
  },
  {
    name: "Client Account Type",
    id: "clientAccountType",
  },
  {
    name: "Client Name",
    id: "clientName",
  },
  {
    name: "Client Address",
    id: "clientAddress",
  },
  {
    name: "Client Account Number",
    id: "clientAccountNumber",
  },
  {
    name: "Billing Type",
    id: "billingType",
  },
  {
    name: "Primary Insurance Name",
    id: "primaryInsuranceName",
  },
  {
    name: "Primary Insurance Code",
    id: "primaryInsuranceCode",
  },
  {
    name: "Secondary Insurance Name",
    id: "secondaryInsuranceName",
  },
  {
    name: "Secondary Insurance Code",
    id: "secondaryInsuranceCode",
  },
  {
    name: "Tertiary Insurance Name",
    id: "tertiaryInsuranceName",
  },
  {
    name: "Tertiary Insurance Code",
    id: "tertiaryInsuranceCode",
  },
  {
    name: "Status",
    id: "status",
  },
  {
    name: "Order Id",
    id: "orderId",
  },
  {
    name: "SSN",
    id: "SSN",
  },
];

export enum AuthFlowPaths {
  LOGIN = "/login",
  NEW_PASSWORD_SETUP = "/reset_password",
  EMAIL_CONFIRMATION = "/account_setup/email_confirmation",
  OTP_SETUP = "/otp_verification",
  MFA_SETUP = "/account_setup/mfa_setup",
  MFA_CONFIRMATION = "/account_setup/mfa_confirmation",
  FORGOT_PASSWORD = "/account_setup/forgot_password",
  FORGOT_PASSWORD_SENT = "/account_setup/forgot_password_sent",
  PASSWORD_UPDATED = "/password_updated",
}

export enum ApplicationPaths {
  DASHBOARD = "/dashboard",
  HUB = "/d/hub",
  OUTREACH = "/d/outreach",
}

export enum PublicPaths {
  ACCESS_DENIED = "/403",
  PAGE_NOT_FOUND = "/404",
  MAINTENANCE = "/maintenance",
  MAINTENANCE_LOGIN = "/maintenance-login",
  POLICY = "/legal/policy",
  TERMS = "/legal/terms-and-conditions",
}

export enum MaintenancePaths {
  MAINTENANCE = "/maintenance",
  MAINTENANCE_LOGIN = "/maintenance-login",
  MFA_CONFIRMATION = "/account_setup/mfa_confirmation",
}

export const accessModules = [
  "lab_orders",
  "unsigned_orders",
  "critical_results",
  "new_results",
  "scheduled",
  "pending_results",
  "rejected_orders",
  "needs_action",
  "order_add-ons",
  "error_queue",
  "patients",
  "test_menu",
  "clients",
  "providers",
  "collections",
  "users",
  "supplies",
  "reports",
  "supply_request",
  "new_request",
  "partially_fulfilled",
  "fulfilled",
  "settings",
  "schedule",
  "lab_activity",
  "lab_all_records",
  "network_labs",
  "compendium_manager",
  "my_test_compendium",
  "network_compendium",
  "message_center",
  "advanced_search",
  "global_admin",
  "report_builder",
] as const;
export type AccessModules = (typeof accessModules)[number];

export enum SessionStatus {
  loading = "loading",
  authenticated = "authenticated",
  unauthenticated = "unauthenticated",
}

export enum UserNavigationActions {
  noaction,
  logout,
}

export enum ECognitoExceptions {
  UserNotConfirmedException = "UserNotConfirmedException",
  NotAuthorizedException = "NotAuthorizedException",
  LimitExceededException = "LimitExceededException",
  PasswordResetRequiredException = "PasswordResetRequiredException",
}

export enum ECognitoChallenges {
  EMAIL_CONFIRMATION = "EMAIL_CONFIRMATION",
  NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED",
  OTP_SETUP = "CUSTOM_CHALLENGE",
  SOFTWARE_TOKEN_SETUP = "SOFTWARE_TOKEN_SETUP",
  SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA",
  OK = "OK",
  LOGIN = "LOGIN",
}

export enum ClientManageTabs {
  CLIENT_INFORMATION = "clientInformation",
  TRENDS = "trends",
  PANELS = "panels",
  SUPPLIES = "supplies",
  ASSET_TRACKING = "Asset tracking",
  NOTES = "notes",
  BILLING = "billing",
  PREFERENCES = "preferences",
}

export enum OrderManageTabs {
  ORDER_DETAILS = "orderDetails",
  ATTACHMENTS = "attachments",
}

export enum PatientTabs {
  PATIENT_INFORMATION = "patientInformation",
  ORDER_HISTORY = "orderHistory",
  DOCUMENT_CENTER = "documentCenter",
}

export enum ClientManageSubTabs {
  OVERVIEW = "overview",
  USERS = "users",
  CLINICIANS = "clinicians",
  CONTRACTS = "contracts",
  LOCATIONS = "locations",
  DISPATCH = "dispatch",
  REVENUE = "revenue",
  PROVIDERS = "providers",
  PATIENTS = "patients",
}

export enum CompendiumManagerTabs {
  TEST_PANELS = "testPanels",
  TESTS = "tests",
}

export enum OrderManagerTabs {
  ORDER_DETAILS = "orderDetails",
  ATTACHMENTS = "attachments",
}

export enum CompendiumStates {
  Active = "active",
  Inactive = "inactive",
  Pending = "pending",
}

export enum PhysicianStates {
  Active = "active",
  Inactive = "inactive",
  Pending = "pending",
}

export enum FilterTypes {
  Labs = "Labs",
  Orders = "Orders",
  Patients = "Patients",
  Tests = "Result Components",
  Panels = "Panels",
}

export enum GlobalFilterActionTypes {
  SET_FILTER_OPTIONS = "SET_FILTER_OPTIONS",
  SELECT_FILTER = "SELECT_FILTER",
}

export enum SexType {
  Male = "Male",
  Female = "Female",
}

export const MAX_FILE_SIZE = 9000000; //kb = 9mb

export const States = [
  { name: "Alabama", shortName: "AL" },
  { name: "Alaska", shortName: "AK" },
  { name: "Arizona", shortName: "AZ" },
  { name: "Arkansas", shortName: "AR" },
  { name: "California", shortName: "CA" },
  { name: "Colorado", shortName: "CO" },
  { name: "Connecticut", shortName: "CT" },
  { name: "Delaware", shortName: "DE" },
  { name: "Florida", shortName: "FL" },
  { name: "Georgia", shortName: "GA" },
  { name: "Hawaii", shortName: "HI" },
  { name: "Idaho", shortName: "ID" },
  { name: "Illinois", shortName: "IL" },
  { name: "Indiana", shortName: "IN" },
  { name: "Iowa", shortName: "IA" },
  { name: "Kansas", shortName: "KS" },
  { name: "Kentucky", shortName: "KY" },
  { name: "Louisiana", shortName: "LA" },
  { name: "Maine", shortName: "ME" },
  { name: "Maryland", shortName: "MD" },
  { name: "Massachusetts", shortName: "MA" },
  { name: "Michigan", shortName: "MI" },
  { name: "Minnesota", shortName: "MN" },
  { name: "Mississippi", shortName: "MS" },
  { name: "Missouri", shortName: "MO" },
  { name: "Montana", shortName: "MT" },
  { name: "Nebraska", shortName: "NE" },
  { name: "Nevada", shortName: "NV" },
  { name: "New Hampshire", shortName: "NH" },
  { name: "New Jersey", shortName: "NJ" },
  { name: "New Mexico", shortName: "NM" },
  { name: "New York", shortName: "NY" },
  { name: "North Carolina", shortName: "NC" },
  { name: "North Dakota", shortName: "ND" },
  { name: "Ohio", shortName: "OH" },
  { name: "Oklahoma", shortName: "OK" },
  { name: "Oregon", shortName: "OR" },
  { name: "Pennsylvania", shortName: "PA" },
  { name: "Rhode Island", shortName: "RI" },
  { name: "South Carolina", shortName: "SC" },
  { name: "South Dakota", shortName: "SD" },
  { name: "Tennessee", shortName: "TN" },
  { name: "Texas", shortName: "TX" },
  { name: "Utah", shortName: "UT" },
  { name: "Vermont", shortName: "VT" },
  { name: "Virginia", shortName: "VA" },
  { name: "Washington, D.C.", shortName: "D.C." },
  { name: "West Virginia", shortName: "WV" },
  { name: "Wisconsin", shortName: "WI" },
  { name: "Wyoming", shortName: "WY" },
];

export const COMPENDIUM_MANAGEMENT_FILE_KEY_PREFIX =
  "app/private/compendiums/laboratory";

export const CLIENT_FILE_KEY_PREFIX = "app/private/clients";
export const PATIENT_FILE_KEY_PREFIX = "app/private/patients";
export const ORDER_FILE_KEY_PREFIX = "app/private/orders";

export enum TestMenusTabs {
  TEST_MENUS = "testMenus",
  ALL_TEST = "allTests",
}

export enum SupplyRequestsStates {
  New = "New",
  Partial = "Partial",
  Fulfilled = "Fulfilled",
}

export enum ClientsStatus {
  Active = "active",
  Pending = "pending",
}

export enum CollectionAssignmentsTabs {
  WORKLIST = "worklist",
  CALENDAR_VIEW = "calendarView",
}

export const CUSTOM_DATES: Array<CustomDate> = [
  { name: "Today", from: new Date(), to: new Date() },
  { name: "Yesterday", from: startOfYesterday(), to: startOfYesterday() },
  {
    name: "This Week",
    from: startOfWeek(new Date()),
    to: endOfWeek(new Date()),
  },
  {
    name: "Last Week",
    from: startOfWeek(subWeeks(new Date(), 1)),
    to: endOfWeek(subWeeks(new Date(), 1)),
  },
  {
    name: "This Month",
    from: startOfMonth(new Date()),
    to: endOfMonth(new Date()),
  },
  {
    name: "Last Month",
    from: startOfMonth(subMonths(new Date(), 1)),
    to: endOfMonth(subMonths(new Date(), 1)),
  },
];

export const LAB_ORDER_STATUS = [
  { label: "Placed", value: "new_order" },
  { label: "In Progress", value: "in_progress" },
  { label: "Collected", value: "needs_action" },
  { label: "Critical", value: "critical" },
  { label: "Rejected", value: "rejected" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Resulted", value: "resulted" },
  { label: "Draft", value: "draft" },
];

export const PANEL_STATUS = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Pending", value: "pending" },
  { label: "Archived", value: "archived" },
];

export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const patientsTableColumns: { id: string; name: string }[] = [
  { id: "fname", name: "First Name" },
  { id: "lname", name: "Last Name" },
  { id: "birthDate", name: "DOB" },
  { id: "mrn", name: "MRN" },
  { id: "gender", name: "Gender" },
  { id: "clientName", name: "Client Name" },
  { id: "lastKnownClientId", name: "Client Id" },
  { id: "address", name: "Address" },
  { id: "cellPhone", name: "Cell Phone" },
  { id: "actions", name: "Actions" },
];

export const labOrdersTableColumns: { id: string; name: string }[] = [
  { id: "orderId", name: "Order Id" },
  { id: "firstName", name: "First Name" },
  { id: "lastName", name: "Last Name" },
  { id: "dob", name: "DOB" },
  { id: "orderDate", name: "Ordered Date" },
  { id: "occurrenceDateTime", name: "Occurrence Date" },
  { id: "resultDate", name: "Resulted Date" },
  { id: "orderingLab", name: "Ordering Lab" },
  { id: "performingLab", name: "Performing Lab" },
  { id: "status", name: "Status" },
  { id: "options", name: "Options" },
];

export const panelsTableColumns: { id: string; name: string }[] = [
  { id: "name", name: "Panel Name" },
  { id: "synonym", name: "Panel Synonym" },
  { id: "code", name: "Panel Code" },
  { id: "loincCodes", name: "LOINC" },
  { id: "status", name: "Status" },
  { id: "laboratoryName", name: "Performing Lab" },
  { id: "price", name: "Price" },
  { id: "published", name: "Published" },
];

export const testsTableColumns: { id: string; name: string }[] = [
  { id: "name", name: "Result Component Name" },
  { id: "synonym", name: "Synonym" },
  { id: "testResultCode", name: "Result Component Code" },
  { id: "loincCodes", name: "Result LOINC" },
  { id: "lastOrdered", name: "Last Ordered" },
];

export const orderStatus = (status: string) => {
  switch (status) {
    case "needs_action":
      return "Needs Action";
    case "rejected":
      return "Rejected";
    case "critical":
      return "Critical";
    case "cancelled":
      return "Cancelled";
    case "resulted":
      return "Resulted";
    case "new_order":
      return "New Order";
    case "in_progress":
      return "In Progress";
    case "collected":
      return "Collected";
    case "draft":
      return "Draft";
    default:
      return "New Order";
  }
};
